import { useEffect, useState } from 'react';
import { useUserAuth } from '../../context/UserAuthContext';
import EnquiryCard from './EnquiryCard';
import axios from 'axios';

const VendorEnquire = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const { user, language, token } = useUserAuth();
    const merchant_id = user?.uid;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

    const fetchEnquiries = async () => {
        if (!merchant_id) return;
        setLoading(true);
        try {
            const res = await axios.get(`${base_url}/api/v1/requests/vendor/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            setData(res.data);
        } catch (error) {
            console.log('error fetching vendor enquiry', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEnquiries();
    }, [merchant_id, token]);

    const filteredData = data.filter((vendor) =>
        vendor?.name?.toLowerCase().includes(searchQuery?.toLowerCase())
    );

    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card border-0 shadow-sm">
                            <div className='card-header d-flex justify-content-between align-items-center' style={{ backgroundColor: '#085f9a' }}>
                                <h4 className='text-white mb-0'>User Enquiries</h4>
                                <div className='w-25'>
                                    <input
                                        type="text"
                                        placeholder='Search Enquiry'
                                        className='form-control'
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card-body">
                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        {filteredData?.length > 0 ? (
                                            <div className="row g-4">
                                                {filteredData.map((item, index) => (
                                                    <EnquiryCard
                                                        key={item.id}
                                                        item={item}
                                                        sno={index + 1}
                                                        onUpdate={fetchEnquiries}
                                                    />
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="text-center py-5">
                                                <div className="empty-state">
                                                    <img
                                                        src="https://cdn-icons-png.flaticon.com/512/4076/4076478.png"
                                                        alt="No enquiries"
                                                        style={{ width: '120px', opacity: 0.5 }}
                                                    />
                                                    <p className="mt-3 text-muted">
                                                        {language === 'en'
                                                            ? "You haven't received any enquiries yet"
                                                            : "आपको अभी तक कोई इन्क्वायरी प्राप्त नहीं हुई है"}
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorEnquire;